<script>
import PageHeader from "@/components/page-header.vue";
import Layout from "@/views/layouts/main.vue";
import storeAdd from "@/views/pages/Dilfoods/Restaurants/Stores/add.vue";
import axios from "axios";
import { StorePath, USERSPATH } from "@/path";
import Swal from "sweetalert2";
import zomatoicon from "@/assets/images/platform-icon-zomato.svg";
import swiggyicon from "@/assets/images/platform-swiggy.svg";
import growthfalcon from "@/assets/images/growthfalcon.png";
import magicpin from "@/assets/images/magicpin.png";
import thrive from "@/assets/images/thrive-platform.png";
import uengage from "@/assets/images/uengage-platform.jpeg";
import toggle_store from "@/views/pages/Dilfoods/Restaurants/Stores/toggle_store";
import ownly from "@/assets/images/platform_ownly_logo.png";
import hungerbox from "@/assets/images/platform_hungerbox_logo.png";
import items from "./items.vue";
import SelectWithSearch from "../../Common/SelectWithSearch.vue";
export default {
  components: {
    toggle_store,
    Layout,
    PageHeader,
    "store-add": storeAdd,
    items,
    SelectWithSearch,
  },
  computed: {
    zomatoicon() {
      return zomatoicon;
    },
    swiggyicon() {
      return swiggyicon;
    },
    thrive() {
      return thrive;
    },
    USERSPATH() {
      return USERSPATH;
    },
    uengage() {
      return uengage;
    },
    growthfalcon() {
      return growthfalcon;
    },
    magicpin() {
      return magicpin;
    },
    ownly() {
      return ownly;
    },
    hungerbox() {
      return hungerbox;
    },
  },
  data() {
    return {
      title: "Locations",
      items: [
        {
          text: "List",
        },
        {
          text: "Location",
          active: true,
        },
      ],
      stores: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      filter: [],
      fields: [
        { key: "r_id", label: "Ref ID", class: "d-none d-md-table-cell" },
        { key: "name", label: "Name" },
        {
          key: "account_manager",
          label: "AM",
        },
        { key: "brand", label: "Brand" },
        { key: "city", label: "City" },
        { key: "assoc_platforms", label: "Platforms" },   
        {
          key: "is_deactive",
          label: "Temporary Status",
          class: "d-none d-md-table-cell",
        },
        "permanent_status",
        { key: "actions", label: "Actions", class: "d-none d-md-table-cell" },
      ],
      restaurants: [],
      selected_store: null,
      selected_menu: null,
      store_reload: 0,
      current_page: 1,
      search: "",
      trash: "",
      storeToggleData: {},
      storeToggleRevert: null,
      up_status: true,
      manager: null,
      loading: false,
      statusComments: '',
      selectedStoreForStatus: null,
      processing_permanent_status: null,
      processing_temp_status: null,
    };
  },
  mounted() {
    this.getStores();
  },
  watch: {
    current_page() {
      this.getStores();
    },
    search() {
      this.getStores();
    },
    trash() {
      this.getStores();
    },
    up_status() {
      this.getStores();
    },
    manager() {
      this.getStores();
    },
  },
  methods: {
    getAbbreviation(name) {
      return name
        .split(" ")
        .map((word) => word[0])
        .join("")
        .toUpperCase();
    },
    getIcon(v) {
      if (!v) return null;
      let platform = v.toLowerCase();
      if (platform == "zomato") {
        return this.zomatoicon;
      } else if (platform == "swiggy") {
        return this.swiggyicon;
      } else if (platform == "thrive") {
        return this.thrive;
      } else if (platform == "uengage") {
        return this.uengage;
      } else if (platform == "magicpin") {
        return this.magicpin;
      } else if (platform == "growthfalcon" || platform == "growthfalcons") {
        return this.growthfalcon;
      } else if (platform == "ownly") {
        return this.ownly;
      } else if (platform == "hungerbox") {
        return this.hungerbox;
      }
    },
    async showItems(v, m) {
      this.selected_store = v;
      this.selected_menu = m;
      this.$bvModal.show("bv-items-list");
    },
    async getStores() {
      try {
        let params = {
          page: this.current_page,
          search: this.search,
          manager: this.manager,
        };
        if (this.trash == true) {
          params.trash = true;
        }
        let res = await axios.get(this.base_url + StorePath.GET_STORES, {
          params: params,
        });
        if (res.data.status) {
          this.stores = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async pushToUrbanPiper(id) {
      try {
        let res = await axios.post(
          this.base_url + StorePath.PUSH_TO_UP + "/" + id
        );
        if (res.data.status) {
          Swal.fire({
            title: "Store Pushed To Urban Piper Successfully",
            showCancelButton: true,
          });
        } else {
          throw new Error(res.data.message);
        }
      } catch (e) {
        console.log(e);
        this.$store.commit("setLoader", false);
        Swal.fire({
          title: e.message,
          showCancelButton: true,
        });
      }
    },
    deleteData(store) {
      let _this = this;
      let title = store.deleted_at 
        ? "Are you sure to restore store?" 
        : "Are you sure to delete store (Also disable urban piper)?";
      
      Swal.fire({
        title: title,
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't save`,
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          _this.processing_permanent_status = store.id;
          try {
            let res = await axios.delete(
              this.base_url + StorePath.DELETE_STORE + "/" + store.id
            );
            if (res.data.status) {
              Swal.fire("Saved!", "", "success");
              _this.getStores();
            } else {
              Swal.fire("Failed to update store", "", "info");
              _this.getStores(); // Revert UI
            }
          } catch (e) {
            Swal.fire("Error updating store", "", "error");
            _this.getStores();
          } finally {
            _this.processing_permanent_status = null;
          }
        } else {
           _this.getStores(); // Revert UI on cancel/deny
           if (result.isDenied) {
             Swal.fire("Changes are not saved", "", "info");
           }
        }
      });
    },
    onStoreToggleModalHide() {
      // let index = this.stores.data.findIndex(f => f.id == this.storeToggleData.store.id);
      // if(index != -1){
      //   this.stores.data[index].platform_data[this.storeToggleData.platform_data.text].is_enabled = this.storeToggleRevert ? 'enable' : 'disable';
      // }
      this.getStores();
    },
    setToggle(v) {
      this.storeToggleRevert = v;
    },
    setEdit(v) {
      this.selected_store = v;
      this.$root.$emit("bv::toggle::collapse", "add-store-sidebar");
    },
    reloadStore() {
      this.selected_store = null;
      this.getStores();
      this.$root.$emit("bv::toggle::collapse", "add-store-sidebar");
    },
    toggleStatus(v) {
      this.selected_store = v;
      this.$root.$emit("bv::toggle::collapse", "toggle-store");
    },
    openTimer(e, store, platform_data) {
      this.storeToggleData = {
        action: e,
        store: store,
        platform_data: platform_data,
      };

      this.$bvModal.show("bv-toggle-store");
    },
    async downloadStoreToggles() {
      try {
        let res = await axios.get(
          "https://pos-webhook-api.dilfoods.in/v1/order/getStoreToggleReport",
          {
            responseType: "blob", // Ensures response is treated as a binary file
          }
        );

        // Create a Blob from the response data
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a download link
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "StoreToggleReport.xlsx"); // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    async toggleStore(e, store, platform_data) {
      try {
        Swal.fire({
          title: "Please wait this might take longer",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
        this.storeToggleRevert = !e;
        let res = await axios.post(this.base_url + StorePath.STORE_TOGGLE_UP, {
          store_id: store.id,
          platforms: platform_data.text,
          action: e ? "enable" : "disable",
        });
        if (res.data.status) {
          this.$bvToast.toast(
            platform_data.text +
              "of store " +
              store.name +
              (e ? " Enabled Successfully" : " Disabled Successfully"),
            {
              title: `Store Toggled`,
              variant: "success",
              solid: true,
            }
          );
          this.getStores();
        } else {
          this.$bvToast.toast("Failed to toggle", {
            title: `Store Toggled`,
            variant: "danger",
            solid: true,
          });
        }
      } catch (e) {
        console.log(e);
      } finally {
        Swal.close();
      }
      this.$bvModal.hide("bv-toggle-store");
    },
    async toggleStoreStatus(event, store) {
      this.loading = true;
      this.processing_temp_status = store.id;
      const isDeactive = !event;
      
      if (isDeactive) {
        // Show modal for comments when deactivating
        this.selectedStoreForStatus = store;
        this.statusComments = '';
        this.$bvModal.show('bv-status-comments');
        this.loading = false;
        return;
      }
      
      try {
        Swal.fire({
          title: "Please wait this might take longer",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await axios.post(this.base_url + StorePath.STORE_TOGGLE_STATUS, {
          store_id: store.id,
          is_deactive: isDeactive,
          comments: null
        });
        
        if (response.data.status) {
          this.$bvToast.toast(response.data.data.message, {
            title: 'Store Status Updated',
            variant: 'success',
            solid: true
          });
          this.getStores();
        } else {
          this.$bvToast.toast('Failed to update store status', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.error('Error toggling store status:', error);
        this.$bvToast.toast('Failed to update store status', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        Swal.close();
        this.loading = false;
        this.processing_temp_status = null;
      }
    },
    async confirmDeactivation() {
      if (!this.statusComments.trim()) {
        this.$bvToast.toast('Please provide a reason for deactivation', {
          title: 'Validation Error',
          variant: 'warning',
          solid: true
        });
        return;
      }
      
      
      this.loading = true;
      this.processing_temp_status = this.selectedStoreForStatus.id;
      try {
        Swal.fire({
          title: "Please wait this might take longer",
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
        const response = await axios.post(this.base_url + StorePath.STORE_TOGGLE_STATUS, {
          store_id: this.selectedStoreForStatus.id,
          is_deactive: true,
          comments: this.statusComments
        });
        
        if (response.data.status) {
          this.$bvToast.toast(response.data.data.message, {
            title: 'Store Deactivated',
            variant: 'success',
            solid: true
          });
          this.getStores();
          this.processing_temp_status = null;
          this.$bvModal.hide('bv-status-comments');
        } else {
          this.getStores();
          this.$bvToast.toast('Failed to deactivate store', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
        }
      } catch (error) {
        console.error('Error deactivating store:', error);
        this.getStores();
        this.$bvToast.toast('Failed to deactivate store', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        Swal.close();
        this.loading = false;
        this.processing_temp_status = null;
      }
    },
    showStatusComments(store) {
      this.selectedStoreForStatus = store;
      this.statusComments = store.latest_status_log?.comments || '';
      this.$bvModal.show('bv-status-comments');
    },
    onStatusCommentsModalHide() {
      if (this.processing_temp_status) {
        this.processing_temp_status = null;
      }
      this.selectedStoreForStatus = null;
      this.statusComments = '';
    },
    normalizedPlatformKeys(platform_data) {
      if (!platform_data) return [];
      const normalized = new Set();
      Object.keys(platform_data).forEach(key => {
        let k = key.toLowerCase();
        if (k === 'growthfalcon') k = 'growthfalcons';
        normalized.add(k);
      });
      return Array.from(normalized);
    },
    getPlatformData(platform_data, key) {
      if (!platform_data) return { text: key };
      // Try exact match
      if (platform_data[key]) return { ...platform_data[key], text: key };
      // Try fuzzy match
      for (const k in platform_data) {
        if (k.toLowerCase() === key.toLowerCase() || (k.toLowerCase() === 'growthfalcon' && key === 'growthfalcons')) {
          return { ...platform_data[k], text: k };
        }
      }
      return { text: key };
    },
    isPlatformEnabled(platform_data, key) {
      const data = this.getPlatformData(platform_data, key);
      return data.is_enabled === 'enable';
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12 p-1">
        <div class="card">
          <div class="card-body p-0 p-sm-2" style="margin-bottom: 50px">
            <div class="row">
              <div class="col-md-8">
                <b-button
                  v-b-toggle.add-store-sidebar
                  @click="() => (this.selected_store = null)"
                  class="btn btn-primary mb-10 pb-10"
                  >Add Location</b-button
                >
                <!--                <label class="d-inline-flex align-items-center mr-5 ml-5">-->
                <!--                  Urban Piper Status:&nbsp;-->
                <!--                  <b-form-checkbox switch v-model="up_status"></b-form-checkbox>-->
                <!--                </label>-->
              </div>
              <b-sidebar
                id="add-store-sidebar"
                title="Add Store"
                backdrop-variant="dark"
                backdrop
                shadow
                right
                width="485px"
                v-if="
                  $store.state.authfack.user.permissions.filter(
                    (f) => f.name == 'StoreEdit'
                  ).length > 0 ||
                  $store.state.authfack.user.roles.filter(
                    (f) => f.name == 'SuperAdmin'
                  ).length > 0
                "
              >
                <store-add
                  :selected_store="selected_store"
                  @reload="reloadStore"
                  :key="store_reload"
                ></store-add>
              </b-sidebar>
              <b-modal
                id="bv-toggle-store"
                hide-footer
                @hide="onStoreToggleModalHide"
              >
                <toggle_store
                  @setToggle="setToggle"
                  :data="storeToggleData"
                ></toggle_store>
              </b-modal>
              <b-modal
                id="bv-items-list"
                size="xl"
                hide-footer
                :title="
                  selected_store?.name +
                  ' - ' +
                  selected_store?.brand.name +
                  ' - ' +
                  selected_menu?.menu
                "
              >
                <items
                  :selected_store="selected_store"
                  :menu="selected_menu"
                ></items>
              </b-modal>
              <b-modal
                id="bv-status-comments"
                title="Store Status Comments"
                @hide="onStatusCommentsModalHide"
              >
                <div v-if="selectedStoreForStatus">
                  <h6>Store: {{ selectedStoreForStatus.name }}</h6>
                  <p class="text-muted">{{ selectedStoreForStatus.brand.name }}</p>
                  
                  <b-form-group label="Reason for deactivation:" label-for="status-comments">
                    <b-form-textarea
                      id="status-comments"
                      v-model="statusComments"
                      placeholder="Please provide a reason for deactivating this store..."
                      rows="4"
                      required
                    ></b-form-textarea>
                  </b-form-group>
                </div>
                
                <template #modal-footer>
                  <b-button variant="secondary" @click="$bvModal.hide('bv-status-comments')">
                    Cancel
                  </b-button>
                  <b-button 
                    variant="danger" 
                    @click="confirmDeactivation"
                    :disabled="loading || !statusComments.trim()"
                  >
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Mark as temporarily Inactive
                  </b-button>
                </template>
              </b-modal>
              <!-- Search -->
              <div class="col-sm-12 col-md-4 mt-2 mt-sm-0">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right d-flex justify-content-between"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      class="form-control form-control-sm ml-2"
                      debounce="500"
                    ></b-form-input>
                  </label>
                  <label class="d-inline-flex align-items-center">
                    Trash:
                    <b-form-checkbox switch v-model="trash"></b-form-checkbox>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <b-row>
              <b-col sm="4">
                <label>Account Managers</label>
                <SelectWithSearch
                  :search_api="USERSPATH.GET_ACCOUNTMANAGET_USERS"
                  extra_params="&role=AccountManagers"
                  track_by="id"
                  display="name"
                  @selectedOption="(v) => (manager = v)"
                ></SelectWithSearch>
              </b-col>
              <b-col sm="4" style="align-self: flex-end; margin-bottom: 2px">
                <b-button variant="success" @click="downloadStoreToggles()">
                  Download Toggle Report
                </b-button>
              </b-col>
            </b-row>
            <div class="table-responsive mb-0">
              <template>
                <b-table
                  :items="stores.data"
                  :fields="fields"
                  responsive="md"
                  :filter="filter"
                  :current-page="current_page"
                  class="small-font-on-small-screen"
                  primary-key="id"
                >
                  <template v-slot:cell(r_id)="row">
                    {{ row.item.ref_id }}
                  </template>
                  <template v-slot:cell(name)="row">
                    <p style="max-width: 200px">{{ row.item.name }}</p>
                  </template>
                  <template v-slot:cell(brand)="row">
                    <p style="max-width: 200px" class="d-none d-md-block">
                      {{ row.item.brand.name }}
                    </p>
                    <p style="max-width: 200px" class="d-md-none">
                      {{ getAbbreviation(row.item.brand.name) }}
                    </p>
                  </template>
                  <template v-slot:cell(city)="row">
                    <p class="d-none d-md-block">
                      {{ row.item.restaurant.city }}
                    </p>
                    <p class="d-md-none">
                      {{ row.item.restaurant.city.substring(0, 3) }}
                    </p>
                  </template>
                  <template v-slot:cell(account_manager)="row">
                    <p class="d-none d-md-block">
                      {{
                        row.item.restaurant.am
                          ? row.item.restaurant.am.name
                          : ""
                      }}
                    </p>
                    <p class="d-md-none">
                      {{
                        row.item.restaurant.am
                          ? row.item.restaurant.am.name.substring(0, 3)
                          : ""
                      }}
                    </p>
                  </template>
                  <template v-slot:cell(assoc_platforms)="row">
                    <b-row
                      v-for="platformKey in normalizedPlatformKeys(row.item.platform_data)"
                      :key="platformKey"
                      :class="{ 'platform-disabled': row.item.deleted_at != null }"
                    >
                      <b-col cols="4">
                        <img
                          v-if="getIcon(platformKey)"
                          :src="getIcon(platformKey)"
                          style="width: 15px; cursor: pointer;"
                          v-b-tooltip.hover
                          :title="platformKey"
                        />
                        <small v-else class="text-muted" style="font-size: 12px; cursor: pointer;" v-b-tooltip.hover :title="platformKey">
                          <i class="fa fa-globe"></i>
                        </small>
                      </b-col>
                      <b-col cols="4">
                        <b-checkbox
                          size="sm"
                          switch
                          @change="toggleStore($event, row.item, getPlatformData(row.item.platform_data, platformKey))"
                          :checked="isPlatformEnabled(row.item.platform_data, platformKey)"
                          :disabled="row.item.deleted_at != null"
                        ></b-checkbox>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-slot:cell(menu_active)="row">
                    <b-row v-for="(m, mi) in row.item.menu_active" :key="mi">
                      <b-col sm="12">
                        <a
                          href="javascript:void(0);"
                          @click="showItems(row.item, m)"
                        >
                          {{ m.menu }} -
                          {{
                            Number.isInteger(parseFloat(m.live_percentage))
                              ? parseFloat(m.live_percentage).toString()
                              : parseFloat(m.live_percentage).toFixed(2)
                          }}%
                        </a>
                      </b-col>
                    </b-row>
                  </template>
                  <template v-slot:cell(permanent_status)="row">
                    <div>
                      <b-form-checkbox
                        switch
                        :checked="row.item.deleted_at == null"
                        @change="deleteData(row.item)"
                        class="mb-0"
                        :key="row.item.id"
                      ></b-form-checkbox>
                      <p
                        :class="row.item.deleted_at == null ? 'text-success' : 'text-danger'"
                      >
                        <span v-if="processing_permanent_status === row.item.id">
                          {{ row.item.deleted_at == null ? 'Deboarding...' : 'Onboarding...' }}
                        </span>
                        <span v-else>
                          {{ row.item.deleted_at == null ? 'On Boarded' : 'Deboarded' }}
                        </span>
                      </p>
                    </div>
                  </template>
                  <template v-slot:cell(is_deactive)="row">
                    <div :class="{ 'temp-status-disabled': row.item.deleted_at != null }">
                      <b-form-checkbox
                        switch
                        :checked="processing_temp_status === row.item.id ? !!row.item.is_deactive : !row.item.is_deactive"
                        @change="toggleStoreStatus($event, row.item)"
                        :disabled="loading || row.item.deleted_at != null"
                        :key="'cb-temp-' + row.item.id + '-' + (processing_temp_status === row.item.id)"
                      ></b-form-checkbox>
                      <p :class="row.item.is_deactive ? 'text-danger' : 'text-success'">
                         <span v-if="processing_temp_status === row.item.id">
                           {{ row.item.is_deactive ? 'Marking Active...' : 'Marking Inactive...' }}
                         </span>
                         <span v-else>
                           {{ row.item.is_deactive ? 'Temp Inactive' : 'Active' }}
                         </span>
                      </p>
                      <b-button
                        v-if="row.item.is_deactive && row.item.latest_status_log"
                        variant="link"
                        size="sm"
                        @click="showStatusComments(row.item)"
                        class="ml-1 p-0"
                        v-b-tooltip:hover
                        :title="row.item.latest_status_log.comments"
                      >
                        <i class="fa fa-comment text-info"></i>
                      </b-button>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <!-- <b-button
                      v-if="
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'StorePushToUp'
                        ).length > 0 ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="pushToUrbanPiper(row.item.id)"
                      class="mr-2"
                      variant="primary"
                      v-b-tooltip:hover
                      title="Push to urban piper"
                    >
                      <i class="fa fa-cloud-upload-alt"></i>
                    </b-button> -->
                    <b-button
                      v-if="
                        $store.state.authfack.user.permissions.filter(
                          (f) => f.name == 'StoreEdit'
                        ).length > 0 ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="setEdit(row.item)"
                      variant="primary"
                    >
                      <i class="fa fa-pen"></i>
                    </b-button>
                    <b-button
                      v-if="
                        (row.item.deleted_at != null &&
                          $store.state.authfack.user.permissions.filter(
                            (f) => f.name == 'StoreEdit'
                          ).length > 0) ||
                        $store.state.authfack.user.roles.filter(
                          (f) => f.name == 'SuperAdmin'
                        ).length > 0
                      "
                      @click="deleteData(row.item)"
                      variant="success"
                      class="ml-1"
                    >
                      <i class="fa fa-trash-restore"></i>
                    </b-button>
                  </template>
                </b-table>
              </template>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="stores.key"
                      v-model="current_page"
                      :total-rows="stores.total"
                      :per-page="stores.per_page"
                      class="dataTables_paginate"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.custom-control-label::before {
  border: 1px solid #f11818;
}
.custom-switch .custom-control-label::after {
  background-color: #f11818;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #29a900;
  background-color: #29a900;
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

/* Disable temporary status when not onboarded */
.temp-status-disabled {
  opacity: 0.4;
  user-select: none;
  cursor: not-allowed !important;
  filter: grayscale(50%);
}

.temp-status-disabled * {
  cursor: not-allowed !important;
}

/* Disable platform toggles when not onboarded */
.platform-disabled {
  opacity: 0.4;
  user-select: none;
  cursor: not-allowed !important;
  filter: grayscale(50%);
}

.platform-disabled * {
  cursor: not-allowed !important;
}

@media (max-width: 575.98px) {
  /* Bootstrap's 'sm' breakpoint */
  .small-font-on-small-screen {
    font-size: 12px; /* Adjust to your desired small font size */
  }

  /* Adjust font size for table cells */
  .small-font-on-small-screen td,
  .small-font-on-small-screen th {
    color: black !important;
    font-size: 12px; /* Ensure table cells have the smaller font size */
  }
}
.dataTables_paginate {
  display: flex !important;
}
</style>
